import React from "react";

import {GenericTableCellRenderer} from "../Tables/GenericTableCellRenderer";

export function StreamBankTableCellRenderer(props) {
	const {className = ''} = props;

	return <GenericTableCellRenderer
		{...{
			...props,
			className: className + " sb-table-column"
		}}
	/>
}
